module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-category panel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category),
      expression: "category"
    }],
    staticClass: "panel-body"
  }, [_c('header', [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-full"
  }, [_c('h1', [_vm._v(_vm._s(_vm.categoryLabel))]), _vm._v(" "), (_vm.categorySummary) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v("\n                        | " + _vm._s(_vm.categorySummary) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.homeUrl
    }
  }, [_vm._v("\n                            Home\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "breadcrumb-divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.allCategoriesUrl
    }
  }, [_vm._v("\n                            All Categories\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "action-bar flex-none"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.searchUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)]), _vm._v(" "), (_vm.category) ? _c('ParallaxArea', [(_vm.categoryBannerUrl) ? _c('img', {
    attrs: {
      "src": _vm.categoryBannerUrl
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/img/ttto-thumbnail.jpg")
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "thread-controls flex"
  }, [_c('div', {
    staticClass: "flex flex-full"
  }, [_c('TabSelect', {
    attrs: {
      "options": _vm.threadSubsetOptions,
      "value": _vm.threadSubset
    },
    on: {
      "input": function($event) {
        _vm.setThreadSubset($event)
      }
    }
  }), _vm._v(" "), (_vm.threadSubset === 'top') ? _c('DropdownSelect', {
    attrs: {
      "options": _vm.threadSubsetPeriodOptions,
      "value": _vm.threadSubsetPeriod
    },
    on: {
      "input": function($event) {
        _vm.setThreadSubsetPeriod($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-none"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.newThreadUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                    Create Thread\n                ")])], 1)]), _vm._v(" "), _c('ForumThreadList', {
    ref: "threadList",
    attrs: {
      "sortable": true,
      "sortOrder": _vm.threadSortOrder,
      "threads": _vm.threads
    },
    on: {
      "update:sort-order": function($event) {
        _vm.threadSortOrder = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function(ref) {
        var thread = ref.thread;

        return [_c('div', {
          staticClass: "thread-author"
        }, [_c('router-link', {
          attrs: {
            "to": _vm.getAuthorUrl(thread.author)
          }
        }, [_c('ForumAvatar', {
          attrs: {
            "src": thread.author.avatarUrl
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "thread-author-name"
        }, [_vm._v("\n                            " + _vm._s(thread.author.name) + "\n                        ")])], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.canLoadMoreThreads) ? _c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingThreads),
      expression: "loadingThreads"
    }]
  }) : _vm._e(), _vm._v(" "), (!_vm.canLoadMoreThreads) ? _c('div', {
    staticClass: "after-threads-msg"
  }, [_vm._v("\n            That's all, folks!\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.loadingCategory) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), (_vm.categoryNotFound) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('ForumCategoryNotFound')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-89c965f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForumCategory.vue
// module id = 2071
// module chunks = 2